import { TokenCard } from '@modules/Swap/ExchangeView'
import useBalances from '@plug-core/hooks/useBalances'
import useMintCycles from '@plug-core/hooks/useMintCycles'
import { logger } from '@plug-core/logger'
import { formatNumber } from '@plug-core/utils/formatNumber'
import { Button, ListGroup, ListRow, Text } from '@ui'
import React, { PropsWithChildren } from 'react'
import { useNavigate } from 'react-router-dom'

const MintCyclesListItem = ({
  attribute,
  children,
}: PropsWithChildren & {
  attribute: string
}) => (
  <ListRow
    dense
    primary={
      <Text as="span" variant="body-s" weight="regular">
        {attribute}
      </Text>
    }
    trailing={
      <Text as="span" variant="body-s" tone="fg-2" tabular>
        {children}
      </Text>
    }
  />
)

const MintCycles = () => {
  const navigate = useNavigate()
  const { tokensToBalances } = useBalances()

  const {
    inputAmount,
    setInputAmount,
    outAmount,
    icpToken,
    conversionRate,
    error,
    mintInProgress,
    performCyclesMint,
  } = useMintCycles()

  return (
    <div className="mb-3 flex flex-col gap-2.5">
      <TokenCard
        token={icpToken}
        amount={inputAmount}
        setAmount={setInputAmount}
        direction="from"
        error={undefined}
        showBalance
        disableTokenPicker
        tokensToBalances={tokensToBalances}
      />
      <ListGroup>
        <MintCyclesListItem attribute="You receive">
          {formatNumber(outAmount, 'TC')}
        </MintCyclesListItem>
        {conversionRate && (
          <MintCyclesListItem attribute="Conversion rate">
            1 ICP = {formatNumber(conversionRate, 'TC')}
          </MintCyclesListItem>
        )}
      </ListGroup>
      <Button
        variant="primary"
        disabled={!!error}
        loading={mintInProgress}
        onClick={() =>
          performCyclesMint()
            .then(() => navigate(-1))
            .catch(logger.error)
        }
        fullWidth
      >
        {error || 'Mint cycles'}
      </Button>
    </div>
  )
}

export default MintCycles
